(function () {
  'use strict';

  /* ---------- scroll reveal ---------- */
  var rv = document.querySelectorAll('.rv');
  if ('IntersectionObserver' in window && rv.length) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    rv.forEach(function (el) { io.observe(el); });
  } else {
    rv.forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------- press-and-hold cooling demo ----------
     Time-based easing. The old loop stepped a fixed amount per frame, so it ran
     ~2x fast on 120Hz displays and juddered whenever the framerate dipped. */
  var pad = document.querySelector('[data-demo-pad]');
  if (pad) {
    var temp = document.querySelector('[data-demo-temp]');
    var fill = document.querySelector('[data-demo-fill]');
    var hint = document.querySelector('[data-demo-hint]');
    var WARM = 38, COOL = 21;
    var t = WARM, held = false, lastSpark = 0, last = 0, shown = null;

    function paint() {
      var r = Math.round(t * 10) / 10;
      if (temp && r !== shown) { temp.textContent = r.toFixed(1) + '°'; shown = r; }
      var pct = ((WARM - t) / (WARM - COOL)) * 100;
      if (fill) fill.style.width = Math.max(0, Math.min(100, pct)).toFixed(2) + '%';
      pad.classList.toggle('is-cool', t < WARM - 4);
    }

    function spark(now) {
      if (now - lastSpark < 260) return;
      lastSpark = now;
      var s = document.createElement('span');
      s.className = 'spark';
      s.textContent = '❄';
      s.style.left = (18 + Math.random() * 64) + '%';
      s.style.top = (34 + Math.random() * 34) + '%';
      pad.appendChild(s);
      setTimeout(function () { s.remove(); }, 1200);
    }

    function tick(now) {
      if (!last) last = now;
      var dt = Math.min((now - last) / 1000, 0.05); // clamp tab-switch jumps
      last = now;

      var target = held ? COOL : WARM;
      var rate = held ? 4.2 : 1.5;                  // per second
      t += (target - t) * (1 - Math.exp(-rate * dt)); // exponential ease

      if (held) {
        if (t > COOL + 0.4) spark(now);
        if (hint) hint.textContent = t <= COOL + 1 ? 'Ahhh. That’s the feeling.' : 'Keep holding…';
      } else if (hint && t > WARM - 1) {
        hint.textContent = 'Press and hold — like a paw would';
      }

      paint();
      requestAnimationFrame(tick);
    }

    var down = function (e) { held = true; if (e.cancelable) e.preventDefault(); };
    var up = function () { held = false; };
    ['pointerdown', 'touchstart'].forEach(function (n) { pad.addEventListener(n, down, { passive: false }); });
    ['pointerup', 'pointercancel', 'pointerleave', 'touchend', 'touchcancel'].forEach(function (n) {
      pad.addEventListener(n, up);
    });
    pad.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { held = true; e.preventDefault(); } });
    pad.addEventListener('keyup', function () { held = false; });

    paint();
    requestAnimationFrame(tick);
  }

  /* ---------- product: variant picker + qty clamp + sticky bar ---------- */
  var form = document.querySelector('[data-product-form]');
  if (form) {
    var variants = [];
    var vtag = document.getElementById('VariantData');
    if (vtag) { try { variants = JSON.parse(vtag.textContent); } catch (e) { variants = []; } }

    var selects = form.querySelectorAll('[data-opt]');
    var idField = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var btn = form.querySelector('[data-atc]');

    function match() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var v = variants.find(function (x) {
        return x.options.length === chosen.length && x.options.every(function (o, i) { return o === chosen[i]; });
      });
      if (!v) return;
      if (idField) idField.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      var bp = document.querySelector('[data-buybar-price]');
      if (bp) bp.textContent = v.price;
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
      if (window.history && window.history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u);
      }
    }
    Array.prototype.forEach.call(selects, function (s) { s.addEventListener('change', match); });

    var bar = document.querySelector('.buybar');
    var anchor = document.querySelector('[data-atc]');
    if (bar && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        bar.classList.toggle('is-up', !es[0].isIntersecting);
      }, { threshold: 0 }).observe(anchor);
    }
    var barBtn = document.querySelector('[data-buybar-btn]');
    if (barBtn) barBtn.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
  }
})();

/* ================= v5 interactions ================= */
(function () {
  'use strict';

  /* ---------- layer explorer ----------
     Binds every instance on the page independently. The old version used a
     single document.querySelector, so only the first section ever worked, and
     an auto-advance timer overwrote the user's click ~2.6s later. Both gone. */
  Array.prototype.forEach.call(document.querySelectorAll('[data-lay-root]'), function (root) {
    var slabs = Array.prototype.slice.call(root.querySelectorAll('[data-lay-slab]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-lay-item]'));
    if (!slabs.length) return;

    var n = slabs.length;
    var active = 0;

    function layout() {
      slabs.forEach(function (s, i) {
        var mid = (n - 1) / 2;
        var off = (i - mid) * 76;
        var out = i === active ? 58 : 0;
        s.style.transform =
          'translate(-50%,-50%) rotateX(58deg) rotateZ(-40deg) translateZ(' + (-off + out) + 'px) translateY(' + off * 0.42 + 'px)';
        s.style.zIndex = String(n - i);
        s.classList.toggle('is-on', i === active);
        s.classList.toggle('is-dim', i !== active);
        s.setAttribute('aria-pressed', i === active ? 'true' : 'false');
      });
      items.forEach(function (it, i) {
        it.classList.toggle('is-on', i === active);
      });
    }

    function pick(i) {
      if (i < 0 || i >= n || i === active) return;
      active = i;
      layout();
    }

    slabs.forEach(function (s, i) {
      s.addEventListener('click', function () { pick(i); });
    });

    items.forEach(function (it, i) {
      it.addEventListener('click', function () { pick(i); });
      it.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(i); }
      });
    });

    layout();
  });

  /* ---------- size visualiser ---------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-viz]'), function (viz) {
    var scope = viz.closest('.viz') || document;
    var tag = scope.querySelector('[data-size-data]');
    var data = {};
    if (tag) { try { data = JSON.parse(tag.textContent); } catch (e) { data = {}; } }

    var rect = viz.querySelector('[data-viz-rect]');
    var dog = viz.querySelector('[data-viz-dog]');
    var dims = viz.querySelector('[data-viz-dims]');
    var link = viz.querySelector('[data-viz-link]');
    var btns = Array.prototype.slice.call(viz.querySelectorAll('.viz__btn'));

    var W = [30, 40, 52, 60, 80, 96];
    var H = [26, 34, 44, 50, 64, 78];
    var D = [1.7, 2.1, 2.6, 3, 3.6, 4.4];

    btns.forEach(function (b) {
      var key = b.dataset.size;
      var info = data[key];
      var priceEl = b.querySelector('[data-viz-price]');

      if (info && info.price) {
        if (priceEl) priceEl.textContent = info.price;
        b.disabled = false;
      } else {
        // no matching available variant — say so instead of showing a blank gap
        if (priceEl) priceEl.textContent = 'Sold out';
        b.classList.add('is-out');
      }

      b.addEventListener('click', function () {
        var i = parseInt(b.dataset.scale, 10);
        btns.forEach(function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on');
        if (rect) { rect.style.width = W[i] + '%'; rect.style.height = H[i] + '%'; }
        if (dog) dog.style.fontSize = D[i] + 'rem';
        if (dims) dims.textContent = b.dataset.dims;
        if (link && info && info.id) link.href = link.dataset.base + '?variant=' + info.id;
      });
    });

    var first = btns.filter(function (b) { return !b.classList.contains('is-out'); })[0] || btns[0];
    if (first) first.click();
  });
})();

/* ================= v7: popups ================= */
(function () {
  'use strict';

  var pops = Array.prototype.slice.call(document.querySelectorAll('[data-pop]'));
  if (!pops.length) return;

  var DAY = 86400000;
  var openPop = null;
  var lastFocus = null;
  var lastCloseAt = 0;

  /* Frequency modes:
       always  - every page load
       session - once per visit (resets when the browser session ends)  [default]
       days    - once per N days
     A real signup always suppresses the welcome popup for a year, whatever the mode. */
  function freqOf(pop) { return pop.dataset.popFreq || 'session'; }

  function seen(pop) {
    var key = pop.dataset.popKey;
    try {
      if (localStorage.getItem('cp_pop_done_' + key)) {
        var d = parseInt(localStorage.getItem('cp_pop_done_' + key), 10);
        if (Date.now() < d) return true;
      }
    } catch (e) {}

    var mode = freqOf(pop);
    if (mode === 'always') return false;
    if (mode === 'session') {
      try { return !!sessionStorage.getItem('cp_pop_' + key); } catch (e) { return false; }
    }
    try {
      var v = localStorage.getItem('cp_pop_' + key);
      return !!v && Date.now() < parseInt(v, 10);
    } catch (e) { return false; }
  }

  function mark(pop) {
    var key = pop.dataset.popKey;
    var mode = freqOf(pop);
    if (mode === 'always') return;
    if (mode === 'session') {
      try { sessionStorage.setItem('cp_pop_' + key, '1'); } catch (e) {}
      return;
    }
    var days = parseInt(pop.dataset.popDays, 10) || 30;
    try { localStorage.setItem('cp_pop_' + key, String(Date.now() + days * DAY)); } catch (e) {}
  }

  /* permanent suppression once they've actually converted */
  function markDone(key, days) {
    try { localStorage.setItem('cp_pop_done_' + key, String(Date.now() + days * DAY)); } catch (e) {}
  }

  function focusables(box) {
    return Array.prototype.slice.call(
      box.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])')
    ).filter(function (el) { return el.offsetParent !== null; });
  }

  function open(pop) {
    if (openPop || seen(pop)) return;
    openPop = pop;
    lastFocus = document.activeElement;
    pop.classList.add('is-open');
    requestAnimationFrame(function () { pop.classList.add('is-in'); });
    document.body.style.overflow = 'hidden';
    var f = focusables(pop);
    if (f.length) setTimeout(function () { f[0].focus(); }, 60);
  }

  function close(pop, remember) {
    if (!pop) return;
    if (remember !== false) mark(pop);
    pop.classList.remove('is-in');
    setTimeout(function () {
      pop.classList.remove('is-open');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }, 300);
    openPop = null;
    lastCloseAt = Date.now();
  }

  pops.forEach(function (pop) {
    Array.prototype.forEach.call(pop.querySelectorAll('[data-pop-close]'), function (btn) {
      btn.addEventListener('click', function () { close(pop); });
    });

    // copy-to-clipboard on the code chip
    Array.prototype.forEach.call(pop.querySelectorAll('[data-pop-copy]'), function (chip) {
      chip.addEventListener('click', function () {
        var code = chip.dataset.popCopy;
        var note = pop.querySelector('[data-pop-copied]');
        var done = function () { if (note) { note.textContent = 'Copied — paste it at checkout'; } };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(function () {
            if (note) note.textContent = 'Copy it manually: ' + code;
          });
        } else { done(); }
      });
    });
  });

  document.addEventListener('keydown', function (e) {
    if (!openPop) return;
    if (e.key === 'Escape') { close(openPop); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(openPop);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* welcome: shown only after the shopper engages, so it never stacks on top of
     Shopify's cookie-consent banner at page load. Fires on the first of a
     meaningful scroll (they've started browsing) or the delay elapsing. */
  var welcome = document.querySelector('[data-pop-key="welcome"]');
  if (welcome) {
    // if the form just posted, Shopify reloaded the page — show the code immediately
    var posted = /[?&]customer_posted=true/.test(window.location.search);
    if (posted) {
      welcome.classList.add('is-open');
      requestAnimationFrame(function () { welcome.classList.add('is-in'); });
      openPop = welcome;
      markDone('welcome', 365);
    } else if (!seen(welcome)) {
      var wDelay = Math.max(parseInt(welcome.dataset.popDelay, 10) || 12, 8) * 1000;
      var wFired = false;
      var wFire = function () {
        if (wFired) return;
        wFired = true;
        window.removeEventListener('scroll', wScroll);
        open(welcome);
      };
      // engaged = scrolled past the fold; small grace so it doesn't pop the
      // instant they nudge the page
      var wScroll = function () {
        if (window.scrollY > 420) setTimeout(wFire, 500);
      };
      window.addEventListener('scroll', wScroll, { passive: true });
      // fallback: fire after the delay even if they never scroll — the delay
      // gives the required cookie banner room to be dealt with first
      setTimeout(wFire, wDelay);
    }
  }

  /* exit intent
     Fires for everyone, including shoppers who already saw or took the welcome
     offer. The only guards are: armed (no instant-bounce fires), openPop (never
     stack two dialogs), and a short cooldown so closing one popup doesn't
     immediately trigger the next. Per-session frequency is handled by seen(). */
  var exit = document.querySelector('[data-pop-exit]');
  if (exit && !seen(exit)) {
    var armed = false;
    setTimeout(function () { armed = true; }, 5000); // don't fire on instant bounces

    // desktop: pointer leaves via the top of the viewport
    document.addEventListener('mouseout', function (e) {
      if (!armed || openPop || Date.now() - lastCloseAt < 1500) return;
      if (e.relatedTarget || e.clientY > 8) return;
      open(exit);
    });

    // mobile: fast scroll back to the top (the "I'm done here" gesture)
    var lastY = window.scrollY, lastT = Date.now();
    window.addEventListener('scroll', function () {
      if (!armed || openPop || Date.now() - lastCloseAt < 1500) return;
      var y = window.scrollY, t = Date.now();
      var dt = t - lastT;
      if (dt > 0 && y < lastY) {
        var v = (lastY - y) / dt;
        if (v > 1.6 && y < 260) open(exit);
      }
      lastY = y; lastT = t;
    }, { passive: true });
  }
})();